import angular from 'angular';
import { ssDialogService } from 'app/services';
import { actionIcon } from 'app/components/global';
import controller from './assessment-in-progress-dialog.controller';
import template from './assessment-in-progress-dialog.html';


class dialogService {
  getOptions($event, { message1, message2 }) {
    return {
      controller,
      controllerAs: 'assessmentInProgressDialogVM',
      locals: { message1, message2 },
      escapeToClose: false,
      clickOutsideToClose: false,
      template,
      targetEvent: $event
    };
  }
}

export default angular.module('app.components.advisory.enterpriseModeling.assessmentInProgressDialog', [
  ssDialogService,
  actionIcon
])
  .service('assessmentInProgressDialog', dialogService)
  .name;

console.log('app.components.advisory.enterpriseModeling.assessmentInProgressDialog created');
